import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const normalApi = {
  load (url, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/${url}`,
      {params: params})
  }
}

export default normalApi
